<template>
  <v-row>
    <v-col>
      <app-title>Previous Payments</app-title>
      <previous-payments></previous-payments>
    </v-col>
  </v-row>
</template>

<script>
import previousPayments from "@/components/review/PreviousPayments";
export default {
  name: "previous-Payments",
  components: {
    previousPayments
  }
};
</script>

<style lang="scss" scoped></style>
